var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-card-partner__partner-badge",class:{floating: _vm.floating}},[_c('inline-svg',{attrs:{"src":"/assets/img/icons/heart-circle.svg"}}),_vm._v(" Inclusion Partner ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }